export const COMPONENT_CLASS = {
  CONTEXT_MENU: 'context_menu',
  MODEL_BODY: 'model_body',
  DOCUMENT_BODY_FULL_CONTENT: 'document_body_full_content',
  RICH_SNIPPET: 'rich_snippet',
  DOCUMENT_ACCORDION: 'document_accordion',
} as const

export const COMPONENT_NAME = {
  JURIS_PANORAMA_ACCORDION: 'juris_panorama_accordion',
  BEFORE_MAIN_HEADING: 'before_main_heading',
  JUS_IA_SELECTION_SHORTCUT: 'jus_ia_selection_shortcut',
  JURIS_DETAILS_INLINE: 'juris_details_inline',
  JURIS_DETAILS_MODAL: 'juris_details_modal',
  JUS_IA_RELATED_QUESTIONS_IN_JURIS_DOCVIEW: 'jusia_related_questions_in_juris_docview',
  JUSIA_SIMILAR_DOCUMENTS: 'jusia_similar_documents',
  JURIS_MAIN_CLAIM: 'juris_main_claim',
  PROCEDURAL_ACTS_TAB: 'procedural_acts_tab',
} as const

export const SELECTED_OPTION = {
  JUSIA_EXPLORE_MENU_ITEM_IN_JURIS_DOCVIEW: 'jusia_explore_menu_item_in_juris_docview',
  JUSIA_SELECTION_SHORTCUT_IN_JURIS_DOCVIEW: 'jusia_selection_shortcut_in_juris_docview',
  FIRST_QUESTION_JUSIA_RELATED_QUESTIONS_IN_JURIS_DOCVIEW:
    'first_question_jusia_related_questions_in_juris_docview',
  SECOND_QUESTION_JUSIA_RELATED_QUESTIONS_IN_JURIS_DOCVIEW:
    'second_question_jusia_related_questions_in_juris_docview',
  THIRD_QUESTION_JUSIA_RELATED_QUESTIONS_IN_JURIS_DOCVIEW:
    'third_question_jusia_related_questions_in_juris_docview',
  OPEN_INPUT_QUESTION_JUSIA_RELATED_QUESTIONS_IN_JURIS_DOCVIEW:
    'open_input_question_jusia_related_questions_in_juris_docview',
  JUS_IA: 'jus_ia',
  LAWSUIT_ANALYSIS: 'lawsuit_analysis',
  ASK_JUS_IA: 'ask_jus_ia',
  JUSIA_SIMILAR_DOCUMENTS: 'jusia_similar_documents',
} as const

export const FEATURE_CLASS = {
  AI_LEGAL_SEARCH: 'ai_legal_search',
} as const

export const FEATURE_NAME = {
  SIMILAR_DOCUMENTS: 'similar_documents',
} as const
